// Almacén del JWT. localStorage por defecto (paridad con la app móvil, ver ADR 0010),
// con fallback en memoria para SSR/tests o navegadores sin storage.

export interface TokenStore {
  get(): string | null;
  set(token: string): void;
  clear(): void;
}

export interface TokenStoreOptions {
  /** Storage a usar. Pasar `null` fuerza memoria. Por defecto: globalThis.localStorage. */
  storage?: Storage | null;
  key?: string;
}

const DEFAULT_KEY = 'gp.auth.token';

function resolveStorage(opt: Storage | null | undefined): Storage | null {
  if (opt === null) return null;
  if (opt) return opt;
  try {
    return globalThis.localStorage ?? null;
  } catch {
    return null;
  }
}

export function createTokenStore(options: TokenStoreOptions = {}): TokenStore {
  const key = options.key ?? DEFAULT_KEY;
  const storage = resolveStorage(options.storage);
  let mem: string | null = null;

  if (!storage) {
    return {
      get: () => mem,
      set: (t) => {
        mem = t;
      },
      clear: () => {
        mem = null;
      },
    };
  }

  return {
    get: () => {
      try {
        return storage.getItem(key);
      } catch {
        return mem;
      }
    },
    set: (t) => {
      mem = t;
      try {
        storage.setItem(key, t);
      } catch {
        /* memoria ya actualizada */
      }
    },
    clear: () => {
      mem = null;
      try {
        storage.removeItem(key);
      } catch {
        /* noop */
      }
    },
  };
}
